import as from './AS/Config';
import ihm from './InHouseMethod/Config';

export default {
  ...ihm,
  ...as,
};
